// Prijsberekening, rode vlaggen en plantekst van het intakegesprek. Portering van het losse intake-prototype (TypeScript); logica ongewijzigd.
import { ZORG_CATEGORIE } from "./pakketten";
export const UURTARIEF = 110;
export const SPOED_TOESLAG = 0.25;
export const GEVOELIG_TOESLAG = 0.15;
export const KOPPELING_MIN = 500;
export const KOPPELING_MAX = 1500;
export const MIN_KORTING = 0.1;
export const LEEG = {
    bedrijf: "",
    contact: "",
    contactinfo: "",
    branche: "",
    aanvraag: "",
    doel: "",
    succes: "",
    situatie: "",
    gebruikers: "",
    rollen: "",
    koppelingen: [],
    bestaand: "",
    pers: "",
    gevoelig: false,
    vo: false,
    ai: "",
    zonderControle: false,
    opleverdatum: "",
    spoed: false,
    budget: "",
    beslisser: "",
    kortingGevraagd: false,
    pakketten: [],
    zorg: "geen",
    maatwerk: [],
};
export const KOPPELINGEN = [
    ["crm", "CRM"],
    ["boekhouding", "Boekhouding"],
    ["kvk", "KvK of andere bedrijfsdata"],
    ["betaal", "Betaalprovider"],
    ["anders", "Ander systeem"],
];
export const GEBRUIKERS = [
    ["", "Kies"],
    ["1-5", "1 tot 5"],
    ["6-25", "6 tot 25"],
    ["26-100", "26 tot 100"],
    ["100+", "Meer dan 100"],
];
export const BUDGETTEN = [
    { waarde: "", label: "Nog niet besproken", max: null },
    { waarde: "lt2500", label: "Minder dan € 2.500", max: 2500 },
    { waarde: "2500-5000", label: "€ 2.500 tot € 5.000", max: 5000 },
    { waarde: "5-10", label: "€ 5.000 tot € 10.000", max: 10000 },
    { waarde: "10-25", label: "€ 10.000 tot € 25.000", max: 25000 },
    { waarde: "25+", label: "Meer dan € 25.000", max: Infinity },
];
export const MAATWERK_SIGNALEN = [
    "De vraag past niet in één pakket of een logische combinatie",
    "Het werk is duidelijk groter dan het uren-budget",
    "Meerdere gebruikersgroepen, talen of landen",
    "Koppeling met een systeem zonder bruikbare API",
    "Gevoelige gegevens verwerken zonder duidelijke wettelijke grondslag",
];
export const ZORG_SLUG = {
    basis: "pakket-zorg-basis",
    plus: "pakket-zorg-plus",
    pro: "pakket-zorg-pro",
};
export const PLAN_SLUG = "pakket-plan-van-aanpak";
export const euro = (n) => "€ " + Math.round(n).toLocaleString("nl-NL");
export const rond50 = (n) => Math.round(n / 50) * 50;
export const bereik = (a, b) => (a === b ? euro(a) : `${euro(a)} tot ${euro(b)}`);
export function bereken(g, catalogus) {
    const gekozen = g.pakketten
        .map((s) => catalogus.find((x) => x.slug === s))
        .filter((x) => !!x && x.categorie !== ZORG_CATEGORIE);
    const basis = gekozen.reduce((a, x) => a + x.prijs, 0);
    const minBasis = gekozen.reduce((a, x) => a + rond50(x.prijs * (1 - MIN_KORTING)), 0);
    const toeslagPct = (g.spoed ? SPOED_TOESLAG : 0) + (g.gevoelig ? GEVOELIG_TOESLAG : 0);
    const toeslag = Math.round(basis * toeslagPct);
    const koppelingen = g.koppelingen.length;
    const kLaag = KOPPELING_MIN * koppelingen;
    const kHoog = KOPPELING_MAX * koppelingen;
    const laag = basis + toeslag + kLaag;
    const hoog = basis + toeslag + kHoog;
    const ondergrens = Math.round(minBasis * (1 + toeslagPct)) + kLaag;
    const zorgSlug = g.zorg === "geen" ? undefined : ZORG_SLUG[g.zorg];
    const zorgPakket = zorgSlug ? catalogus.find((x) => x.slug === zorgSlug) : undefined;
    const zorg = zorgPakket ? { naam: zorgPakket.naam, prijs: zorgPakket.prijs } : { naam: "Geen", prijs: 0 };
    const vlaggen = [];
    if (!gekozen.length)
        vlaggen.push("Nog geen pakket gekozen.");
    if (g.spoed && (!g.doel.trim() || !gekozen.length)) {
        vlaggen.push("Spoed zonder duidelijke scope. Eerst scope vastleggen.");
    }
    if (g.pers === "ja" && !g.vo) {
        vlaggen.push("Er zijn persoonsgegevens, maar de verwerkersovereenkomst is nog niet geregeld.");
    }
    if (g.gevoelig && !g.vo && g.pers !== "ja") {
        vlaggen.push("Gevoelige data zonder verwerkersovereenkomst.");
    }
    if (g.zonderControle) {
        vlaggen.push("Klant wil AI zonder menselijke controle laten versturen of publiceren. Niet doen: goedkeuringsstap is verplicht.");
    }
    const budgetMax = BUDGETTEN.find((b) => b.waarde === g.budget)?.max;
    if (gekozen.length && budgetMax != null && budgetMax < ondergrens) {
        vlaggen.push(`Budget ligt onder de minimumprijs (${euro(ondergrens)}).`);
    }
    if (g.kortingGevraagd) {
        vlaggen.push("Klant vraagt korting onder het minimum of betaling achteraf. Eerst overleggen.");
    }
    if (g.maatwerk.length) {
        vlaggen.push(`Maatwerk-signaal (${g.maatwerk.length}). ` +
            (g.pakketten.includes(PLAN_SLUG)
                ? "Plan van aanpak zit in de selectie."
                : "Voeg eerst een Plan van aanpak toe (€ 1.500) en offreer daarna op uren."));
    }
    return {
        gekozen,
        basis,
        minBasis,
        toeslagPct,
        toeslag,
        koppelingen,
        kLaag,
        kHoog,
        laag,
        hoog,
        ondergrens,
        zorg,
        vlaggen,
        uren: Math.round(basis / UURTARIEF),
    };
}
export function planTekst(g, b) {
    const L = [];
    const v = (x) => (x && x.trim() ? x : "(nog niet besproken)");
    const open = [];
    const nodig = (x, label) => {
        if (!x || !x.trim())
            open.push(label);
    };
    nodig(g.doel, "Doel");
    nodig(g.succes, "Succescriterium");
    nodig(g.situatie, "Huidige situatie");
    nodig(g.gebruikers, "Aantal gebruikers");
    nodig(g.pers, "Persoonsgegevens ja of nee");
    nodig(g.budget, "Budget");
    nodig(g.opleverdatum, "Opleverdatum");
    nodig(g.beslisser, "Wie beslist");
    L.push(`PLAN VOOR ${(g.bedrijf || "(klant)").toUpperCase()}`);
    L.push(`Contact: ${v(g.contact)} · ${v(g.contactinfo)}${g.branche ? " · " + g.branche : ""}`, "");
    L.push("AANVRAAG", v(g.aanvraag), "", "DOEL", v(g.doel), `Succes: ${v(g.succes)}`, `Nu: ${v(g.situatie)}`, "");
    L.push("SCOPE");
    if (b.gekozen.length)
        b.gekozen.forEach((x) => L.push(`- ${x.naam} (${euro(x.prijs)}): ${x.omschrijving}`));
    else
        L.push("- Nog geen pakket gekozen");
    L.push(`Gebruikers: ${v(g.gebruikers)}${g.rollen ? ` (${g.rollen})` : ""}`);
    L.push("Koppelingen: " +
        (g.koppelingen.length
            ? g.koppelingen.map((k) => KOPPELINGEN.find((x) => x[0] === k)?.[1] ?? k).join(", ")
            : "geen"));
    L.push(`Bestaand: ${v(g.bestaand)}`, "");
    L.push("DATA EN WET", "Persoonsgegevens: " +
        (g.pers === "ja" ? "ja" : g.pers === "nee" ? "nee" : "(nog niet besproken)") +
        (g.gevoelig ? " · gevoelige data" : "") +
        (g.pers === "ja" ? ` · verwerkersovereenkomst ${g.vo ? "geregeld" : "nog te regelen"}` : ""));
    L.push("AI-acties namens anderen: " +
        (g.ai === "ja" ? "ja, altijd met goedkeuring door een mens" : g.ai === "nee" ? "nee" : "(nog niet besproken)"), "");
    L.push("PLANNING", `Oplevering: ${v(g.opleverdatum)}${g.spoed ? " · SPOED (+25%)" : ""}`, `Beslisser: ${v(g.beslisser)}`, "");
    L.push("PRIJS (excl. btw)");
    if (b.gekozen.length) {
        L.push(`Pakketten: ${euro(b.basis)}`);
        if (g.spoed)
            L.push(`Spoedtoeslag 25%: ${euro(b.basis * SPOED_TOESLAG)}`);
        if (g.gevoelig)
            L.push(`Toeslag gevoelige data 15%: ${euro(b.basis * GEVOELIG_TOESLAG)}`);
        if (b.koppelingen)
            L.push(`Koppelingen (${b.koppelingen}): ${bereik(b.kLaag, b.kHoog)}`);
        L.push(`Totaal: ${bereik(b.laag, b.hoog)}`, `Minimumprijs: ${euro(b.ondergrens)}`, `Uren-budget: ${b.uren} uur (op ${euro(UURTARIEF)} per uur)`);
        L.push(`Betaling: 40% bij start (${bereik(b.laag * 0.4, b.hoog * 0.4)}), 40% bij eerste werkende versie (${bereik(b.laag * 0.4, b.hoog * 0.4)}), 20% bij livegang (${bereik(b.laag * 0.2, b.hoog * 0.2)})`);
        if (g.zorg === "pro") {
            L.push(`Combinatie met Zorg Pro: 5 tot 10% korting op de bouw is mogelijk (${bereik(b.basis * 0.05, b.basis * 0.1)} korting). Alleen in overleg.`);
        }
    }
    else {
        L.push("Nog niet te berekenen.");
    }
    L.push(`Zorg: ${b.zorg.prijs ? `${b.zorg.naam} · ${euro(b.zorg.prijs)} per maand` : "geen"}`, "");
    if (b.vlaggen.length) {
        L.push("AANDACHTSPUNTEN");
        b.vlaggen.forEach((f) => L.push(`! ${f}`));
        L.push("");
    }
    L.push("VERVOLGSTAPPEN");
    let n = 1;
    L.push(`${n++}. Offerte opstellen met pakketinhoud, wat er niet bij zit, betaalplan en 30 dagen geldigheid. Eigenaar keurt goed voor verzending.`);
    if (g.pers === "ja" || g.gevoelig)
        L.push(`${n++}. Verwerkersovereenkomst laten tekenen voor de start.`);
    if (g.maatwerk.length && !g.pakketten.includes(PLAN_SLUG)) {
        L.push(`${n++}. Eerst Plan van aanpak (€ 1.500), daarna offerte op uren met vaste bovengrens.`);
    }
    L.push(`${n++}. Na ondertekende offerte en eerste termijn (40%): kick-off en planning.`);
    L.push(`${n++}. Eerste werkende versie tonen vóór de tweede termijn.`);
    if (open.length)
        L.push("", "NOG TE BESPREKEN", ...open.map((o) => `- ${o}`));
    return L.join("\n");
}
